class customTabs extends HTMLElement {
  constructor() {
    super();

    this.Smain1 = this.querySelectorAll('.swiper-list-item-main :nth-child(1)');
    this.Smain2 =  this.querySelectorAll('.swiper-list-title-main :nth-child(1)');    
    this.swiper_tabs = this.querySelectorAll(".swiper-list-title-main .swiper-list-title");
    this.swiper_tabContents = this.querySelectorAll(".swiper-list-item-main .swiper-list-item");
    this.init();    
  }

  init() {
    this.Smain1.forEach((Smain1_add) => {
      Smain1_add.classList.add('active');
    });
    this.Smain2.forEach((Smain2_add) => {
      Smain2_add.classList.add('active');
    });  
      
    this.swiper_tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        this.swiper_tabContents.forEach((content) => {
          content.classList.remove("active");
        });
        this.swiper_tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        this.swiper_tabContents[index].classList.add("active");
        this.swiper_tabs[index].classList.add("active");
      });
    }); 
  }  
}

customElements.define('custom-tabs', customTabs);